import React, { useState } from 'react';
import Tool from './components/Tool';
import Info from './components/Info';
import './App.css';


function App() {
  
  const [save, setSave] = useState(false);
  return (
    <div id="parent-container">
      <div className="tool">
        <Tool
          save={save}
          setSave={setSave}
        />
      </div>
      <Info />
      </div>
  );
}

export default App;
